export default "assets/images/lock-0730d461.svg";